import { DataPoint } from '@liveoptics/react-ui/dist/types/interfaces/Charts';

export enum ProvisioningContrastGraphOption {
  VCpuOverMempry,
  VCpuOverCapacity,
  MemoryOverVCpu,
  MemoryOverCapacity,
  CapacityOverVCpu,
  CapacityOverMemory
}

export interface ProvisioningContrastPoint extends DataPoint {
  Name: string;
  VCpu: number;
  MemoryGB: number;
  CapacityGB: number;
}
